import { SEARCH_SCOPES } from '@batiflow/contracts';
import { z } from 'zod';

/** A text the router may have parsed as a number ("2026" → 2026): back to text. */
const text = (max: number) =>
  z
    .preprocess(
      (value) =>
        typeof value === 'string' || typeof value === 'number' ? String(value) : undefined,
      z.string().trim().min(1).max(max).optional(),
    )
    .catch(undefined);

/**
 * Search params of /o/$orgId/search: the query and the kind of results, kept in the address so a
 * search can be shared and survives a reload. An invalid value is simply dropped.
 */
export const SearchPageSearchSchema = z.object({
  q: text(100),
  scope: z.enum(SEARCH_SCOPES).optional().catch(undefined),
});
export type SearchPageSearch = z.infer<typeof SearchPageSearchSchema>;
